// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {228: "91e1bfb4b2d6eadd",461: "121bb48c054666d4",689: "2dcaa142d4cea7f6",702: "7478576cb70bd881",}[chunkId] + ".js"
}